import { Menu } from "@shared/type/CommonType";

/** 메시지센터 화면 코드 */
export const FCM_ALARM_MESSAGE_CENTER_CODE = "SN_ETC_ALR_REP_001";

/**
 * 메시지센터 탭을 열기 위한 메뉴 객체.
 *
 * sys_menu/권한에 등록되지 않은 화면을 여는 용도라 사용자 메뉴 목록(menuItems)에서
 * 찾지 않고 이 객체를 직접 handleMenuClick에 넘긴다.
 * - nm_file/cd_module: require.context("@menu") 경로 ./ETC/SN_ETC_ALR_REP_001/SN_ETC_ALR_REP_001.tsx
 * - fg_*: TabToolbar 버튼 노출 플래그(조회만 허용)
 * - skipRec: 최근사용 메뉴(addRec) 기록 생략 — 미등록 메뉴가 최근사용 목록에 남지 않게
 */
export const FCM_ALARM_MESSAGE_CENTER_MENU: Menu & { skipRec: true } = {
  cd_menu: FCM_ALARM_MESSAGE_CENTER_CODE,
  nm_menu: "메시지센터",
  nm_menu_origin: "메시지센터",
  cd_module: "ETC",
  no_pos: "000",
  nm_file: FCM_ALARM_MESSAGE_CENTER_CODE,
  fg_menu: "MNU",
  no_seq: 0,
  no_level: 2,
  cd_menu_parent: null,
  fg_select: "Y",
  fg_insert: "N",
  fg_update: "N",
  fg_delete: "N",
  fg_excel: "N",
  fg_print: "N",
  yn_end: "Y",
  path_arr: [FCM_ALARM_MESSAGE_CENTER_CODE],
  path_origin: [],
  nm_path: "알림 > 메시지센터",
  skipRec: true,
};

/** handleMenuClick 인자 형태로 변환 */
export function messageCenterMenuArgs() {
  const m = FCM_ALARM_MESSAGE_CENTER_MENU;
  const filePath = `./${m.cd_module}/${m.nm_file}/${m.nm_file}`.toUpperCase();
  return [m.cd_menu, m.nm_menu, m.cd_module, filePath, m, m.nm_path ?? ""] as const;
}
